module.exports = __webpack_public_path__ + "static/media/filter.a348fad1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter.svg
// module id = 220
// module chunks = 1